export const SUPPORTED_PLATFORMS = ['WEB_DESKTOP', 'ANDROID', 'ANDROID_TABLET', 'IOS', 'IPAD', 'WEB_DESKTOP', 'WEB_MOBILE', 'WEB_TABLET'];
export type SupportedPlatform = (typeof SUPPORTED_PLATFORMS)[number];
export const SUPPORTED_PLATFORM_DEFAULT = 'WEB_DESKTOP' as const;

export const supportedPlatform: Record<string, SupportedPlatform> = {
	WebDesktop: 'WEB_DESKTOP',
	Android: 'ANDROID',
	AndroidTablet: 'ANDROID_TABLET',
	Ios: 'IOS',
	Ipad: 'IPAD',
	WebMobile: 'WEB_MOBILE',
	WebTablet: 'WEB_TABLET',
} as const;

export function isSupportedPlatform(value?: string): value is SupportedPlatform {
	return typeof value === 'string' && SUPPORTED_PLATFORMS.includes(value);
}

export function sanitizePlatform(platform?: string): SupportedPlatform | undefined {
	return isSupportedPlatform(platform) ? platform : undefined;
}
